export function openExternal(url) {
  const popup = window.open(url || "about:blank", "_blank", "noopener,noreferrer");

  // Older browsers may ignore the noopener feature and return a window handle.
  // Modern browsers generally return null when noopener is active.
  if (popup) popup.opener = null;
  return popup;
}



// WEBPACK FOOTER //
// ./src/util/openExternal.js